(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('faq-slider')) {
  class FaqSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.faq-slider__track');
      this.cards = Array.from(this.querySelectorAll('[data-faq-card]'));
      this.arrows = Array.from(this.querySelectorAll('.faq-slider__arrow'));
      this.progressFill = this.querySelector('.faq-slider__progress-fill');
      this.progressCurrent = this.querySelector('[data-faq-current]');
      this.progressTotal = this.querySelector('[data-faq-total]');
      this.hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      if (!this.track || this.cards.length === 0) return;

      this.applyMode = this.applyMode.bind(this);
      this.updateArrows = this.updateArrows.bind(this);

      this.cards.forEach((card, index) => {
        const toggle = card.querySelector('.faq-card__toggle');
        card.addEventListener('pointerenter', (event) => {
          if (!this.canHover() || event.pointerType !== 'mouse') return;
          clearTimeout(this.hoverTimer);
          this.hoverTimer = setTimeout(() => this.open(index), 140);
        });
        card.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer));
        toggle.addEventListener('focus', () => {
          if (this.canHover()) this.open(index);
        });
        toggle.addEventListener('click', () => {
          if (this.canHover()) {
            this.open(index);
          } else {
            this.toggle(index);
          }
        });
      });

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.step(Number(arrow.dataset.dir)));
      });

      const back = this.querySelector('[data-faq-back]');
      if (back) back.addEventListener('click', (event) => this.backToProduct(event));

      if (this.progressTotal) this.progressTotal.textContent = this.cards.length;
      this.track.addEventListener('scroll', () => {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = setTimeout(() => {
          if (this.canHover()) return;
          if (!this.cards.some((card) => card.classList.contains('is-open'))) {
            const index = this.visibleIndex();
            this.updateProgress(index);
            this.updateArrows(index);
          }
        }, 80);
      }, { passive: true });
      this.hoverQuery.addEventListener('change', this.applyMode);
      this.applyMode();
    }

    disconnectedCallback() {
      if (this.hoverQuery) this.hoverQuery.removeEventListener('change', this.applyMode);
    }

    canHover() {
      return this.hoverQuery.matches;
    }

    applyMode() {
      if (this.canHover()) {
        const current = this.cards.findIndex((card) => card.classList.contains('is-open'));
        this.open(current >= 0 ? current : 0);
      } else {
        this.cards.forEach((card, i) => this.setState(i, false));
      }
      this.updateArrows();
    }

    setState(index, isOpen) {
      const card = this.cards[index];
      if (!card) return;
      card.classList.toggle('is-open', isOpen);
      const toggle = card.querySelector('.faq-card__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    open(index) {
      this.cards.forEach((card, i) => this.setState(i, i === index));
      this.active = index;
      this.updateProgress(index);
      this.updateArrows(index);
      if (this.canHover()) this.keepInView(index);
    }

    keepInView(index) {
      clearTimeout(this.viewTimer);
      this.viewTimer = setTimeout(() => {
        const card = this.cards[index];
        if (!card || this.active !== index) return;
        const trackBox = this.track.getBoundingClientRect();
        const cardBox = card.getBoundingClientRect();
        let delta = 0;
        if (cardBox.right > trackBox.right) delta = cardBox.right - trackBox.right + 2;
        if (cardBox.left < trackBox.left) delta = cardBox.left - trackBox.left - 2;
        if (delta !== 0) {
          const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: delta, behavior: reduce ? 'auto' : 'smooth' });
        }
      }, 650);
    }

    visibleIndex() {
      const x = this.track.scrollLeft;
      let best = 0;
      let bestDistance = Infinity;
      this.cards.forEach((card, i) => {
        const distance = Math.abs(card.offsetLeft - x);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    }

    currentIndex() {
      if (this.canHover()) return this.active || 0;
      const open = this.cards.findIndex((card) => card.classList.contains('is-open'));
      return open >= 0 ? open : this.visibleIndex();
    }

    goTo(index) {
      const card = this.cards[index];
      if (!card) return;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollTo({ left: card.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }

    updateProgress(index) {
      if (!this.progressFill) return;
      const total = this.cards.length;
      const current = Math.min(Math.max(index, 0), total - 1) + 1;
      this.progressFill.style.width = (current / total) * 100 + '%';
      if (this.progressCurrent) this.progressCurrent.textContent = current;
    }

    toggle(index) {
      const isOpen = this.cards[index].classList.contains('is-open');
      this.cards.forEach((card, i) => this.setState(i, i === index && !isOpen));
      this.updateProgress(index);
      if (!isOpen) this.goTo(index);
      this.updateArrows();
    }

    step(direction) {
      const target = Math.min(Math.max(this.currentIndex() + direction, 0), this.cards.length - 1);
      this.goTo(target);
      if (this.canHover()) {
        this.open(target);
      } else {
        this.cards.forEach((card, i) => this.setState(i, false));
        this.updateProgress(target);
      }
      this.updateArrows(target);
    }

    backToProduct(event) {
      const target =
        document.querySelector('[id^="ProductInfo-"]') || document.querySelector('.product__info-wrapper');
      if (!target) return;
      event.preventDefault();
      const header = document.querySelector('.shopify-section-header-sticky');
      const offset = header ? header.offsetHeight : 0;
      const top = target.getBoundingClientRect().top + window.scrollY - offset - 16;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: Math.max(top, 0), behavior: reduce ? 'auto' : 'smooth' });
    }

    updateArrows(index) {
      if (this.arrows.length < 2) return;
      const current = typeof index === 'number' ? index : this.currentIndex();
      this.arrows[0].disabled = current <= 0;
      this.arrows[1].disabled = current >= this.cards.length - 1;
    }
  }

  customElements.define('faq-slider', FaqSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pilz-vergleich"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pv-slider')) {
  customElements.define(
    'pv-slider',
    class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.pv-card__track');
        this.dots = Array.from(this.querySelectorAll('.pv-dot'));
        this.prev = this.querySelector('.pv-arrow--prev');
        this.next = this.querySelector('.pv-arrow--next');
        if (!this.track) return;
        this.count = this.track.children.length;
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
        if (this.prev) this.prev.addEventListener('click', () => this.goTo(this.index() - 1));
        if (this.next) this.next.addEventListener('click', () => this.goTo(this.index() + 1));
        this.track.addEventListener('scroll', () => this.update(), { passive: true });
        this.update();
      }

      index() {
        return Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1));
      }

      goTo(i) {
        const target = Math.min(Math.max(i, 0), this.count - 1);
        this.track.scrollTo({ left: this.track.clientWidth * target, behavior: 'smooth' });
      }

      update() {
        const i = this.index();
        this.dots.forEach((dot, j) => dot.classList.toggle('is-active', i === j));
        if (this.prev) this.prev.disabled = i <= 0;
        if (this.next) this.next.disabled = i >= this.count - 1;
      }
    }
  );
}

if (!customElements.get('pv-compare')) {
  customElements.define(
    'pv-compare',
    class extends HTMLElement {
      connectedCallback() {
        const raw = this.querySelector('[data-pv-data]');
        this.table = this.querySelector('[data-pv-table]');
        this.stack = this.querySelector('[data-pv-stack]');
        this.switchEl = this.querySelector('.pv-switch');
        this.chipView = this.querySelector('.pv-switch__viewport');
        this.chipTrack = this.querySelector('.pv-switch__chips');
        this.chipArrows = Array.from(this.querySelectorAll('.pv-switch__arrow'));
        this.chips = Array.from(this.querySelectorAll('.pv-chip'));

        if (this.chipTrack) {
          this.updateChipNav = this.updateChipNav.bind(this);
          this.chipArrows.forEach((arrow) => arrow.addEventListener('click', () => this.chipStep(Number(arrow.dataset.dir))));
          this.chipTrack.addEventListener('scroll', this.updateChipNav, { passive: true });
          window.addEventListener('resize', this.updateChipNav);
          window.requestAnimationFrame(() => {
            this.centerChip(this.querySelector('.pv-chip.is-active'), false);
            this.updateChipNav();
          });
        }

        if (!raw || !this.table) return;
        try {
          this.data = JSON.parse(raw.textContent);
        } catch (e) {
          return;
        }
        this.titleEl = this.querySelector('[data-pv-title]');
        this.introEl = this.querySelector('[data-pv-intro]');
        this.chips.forEach((chip) => chip.addEventListener('click', () => this.select(chip.dataset.handle, true)));
        const param = new URLSearchParams(window.location.search).get('pilz');
        if (param && param !== this.dataset.fokus && this.find(param)) this.select(param, false);
      }

      disconnectedCallback() {
        if (this.updateChipNav) window.removeEventListener('resize', this.updateChipNav);
      }

      reduceMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      chipStep(direction) {
        const t = this.chipTrack;
        if (!t) return;
        t.scrollBy({ left: direction * Math.max(t.clientWidth * 0.7, 120), behavior: this.reduceMotion() ? 'auto' : 'smooth' });
      }

      centerChip(chip, smooth) {
        const t = this.chipTrack;
        if (!t || !chip) return;
        if (t.scrollWidth <= t.clientWidth + 2) return;
        const left = chip.offsetLeft - (t.clientWidth - chip.offsetWidth) / 2;
        t.scrollTo({ left: Math.max(left, 0), behavior: smooth && !this.reduceMotion() ? 'smooth' : 'auto' });
      }

      updateChipNav() {
        const t = this.chipTrack;
        if (!t) return;
        const max = t.scrollWidth - t.clientWidth;
        const atStart = t.scrollLeft <= 2;
        const atEnd = t.scrollLeft >= max - 2;
        if (this.switchEl) this.switchEl.classList.toggle('is-static', max <= 2);
        if (this.chipView) {
          this.chipView.classList.toggle('has-prev', max > 2 && !atStart);
          this.chipView.classList.toggle('has-next', max > 2 && !atEnd);
        }
        if (this.chipArrows.length === 2) {
          this.chipArrows[0].disabled = atStart;
          this.chipArrows[1].disabled = atEnd;
        }
      }

      find(handle) {
        return this.data.pilze.find((p) => p.handle === handle);
      }

      esc(value) {
        const div = document.createElement('div');
        div.textContent = value == null || value === '' ? '–' : String(value);
        return div.innerHTML;
      }

      select(handle, updateUrl) {
        const fokus = this.find(handle);
        if (!fokus) return;
        const cols = [fokus].concat((fokus.similar || []).map((h) => this.find(h)).filter(Boolean)).slice(0, 4);
        this.table.classList.add('is-updating');
        if (this.stack) this.stack.classList.add('is-updating');
        window.setTimeout(() => {
          this.render(cols);
          this.table.classList.remove('is-updating');
          if (this.stack) this.stack.classList.remove('is-updating');
        }, 150);

        this.chips.forEach((chip) => {
          const active = chip.dataset.handle === handle;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', active ? 'true' : 'false');
          if (active) this.centerChip(chip, updateUrl);
        });

        if (this.titleEl) {
          const tpl = this.titleEl.dataset.template || '[fokus]';
          this.titleEl.innerHTML = this.esc(tpl).replace('[fokus]', '<span class="pv-hl">' + this.esc(fokus.name) + '</span>');
        }
        if (this.introEl) {
          const tpl = this.introEl.dataset.template || '';
          this.introEl.textContent = tpl.replace('[fokus]', fokus.name);
        }

        const section = this.closest('.pv');
        if (section) {
          section.querySelectorAll('.pv-card[data-handle]').forEach((card) => {
            card.classList.toggle('is-fokus', card.dataset.handle === handle);
          });
        }

        this.dataset.fokus = handle;
        if (updateUrl && window.history && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('pilz', handle);
          window.history.replaceState({}, '', url);
        }
      }

      render(cols) {
        const d = this.data;
        const check =
          '<span class="pv-check" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/></svg></span><span class="visually-hidden">Ja</span>';
        const fk = (i) => (i === 0 ? ' is-fokus' : '');

        let head = '<tr><th scope="col" class="pv-table__corner"><span class="visually-hidden">Merkmal</span></th>';
        cols.forEach((p, i) => {
          const img = p.img
            ? '<img class="pv-colhead__img" src="' + p.img + '" alt="" width="64" height="64" loading="lazy">'
            : '<span class="pv-colhead__img pv-colhead__img--empty"></span>';
          const badge = i === 0 ? '<span class="pv-badge">' + this.esc(d.badge) + '</span>' : '';
          head += '<th scope="col" class="pv-table__col' + fk(i) + '"><div class="pv-colhead">' + img + '<span class="pv-colhead__name">' + this.esc(p.name) + '</span>' + badge + '</div></th>';
        });
        head += '</tr>';

        let body = '';
        d.rows.forEach((row) => {
          body += '<tr><th scope="row" class="pv-table__label">' + this.esc(row.label) + '</th>';
          cols.forEach((p, i) => {
            body += '<td class="pv-table__cell' + fk(i) + (row.key === 'latin' ? ' is-latin' : '') + '">' + this.esc(p[row.key]) + '</td>';
          });
          body += '</tr>';
        });
        (d.checks || []).forEach((text) => {
          body += '<tr class="pv-table__checkrow"><th scope="row" class="pv-table__label">' + this.esc(text) + '</th>';
          cols.forEach((p, i) => {
            body += '<td class="pv-table__cell' + fk(i) + '">' + check + '</td>';
          });
          body += '</tr>';
        });
        body += '<tr class="pv-table__actions"><th scope="row" class="pv-table__label"><span class="visually-hidden">Produkt</span></th>';
        cols.forEach((p, i) => {
          body += '<td class="pv-table__cell' + fk(i) + '"><a href="' + p.url + '" class="button ' + (i === 0 ? 'button--primary' : 'button--secondary') + ' pv-table__button">' + this.esc(p.name) + '-Extrakt</a></td>';
        });
        body += '</tr>';

        this.table.querySelector('thead').innerHTML = head;
        this.table.querySelector('tbody').innerHTML = body;
        if (this.stack) this.stack.innerHTML = this.renderStack(cols);
      }

      renderStack(cols) {
        const d = this.data;
        let html = '';
        cols.forEach((p, i) => {
          const img = p.img
            ? '<img class="pv-colhead__img" src="' + p.img + '" alt="" width="56" height="56" loading="lazy">'
            : '<span class="pv-colhead__img pv-colhead__img--empty"></span>';
          const badge = i === 0 ? '<span class="pv-badge pv-stack__badge">' + this.esc(d.badge) + '</span>' : '';
          html += '<article class="pv-stack__card' + (i === 0 ? ' is-fokus' : '') + '"><div class="pv-stack__head">' + img + '<h3 class="pv-stack__name">' + this.esc(p.name) + '</h3>' + badge + '</div><dl class="pv-stack__list">';
          d.rows.forEach((row) => {
            html += '<div class="pv-stack__row"><dt>' + this.esc(row.label) + '</dt><dd' + (row.key === 'latin' ? ' class="is-latin"' : '') + '>' + this.esc(p[row.key]) + '</dd></div>';
          });
          html += '</dl><a href="' + p.url + '" class="button ' + (i === 0 ? 'button--primary' : 'button--secondary') + ' pv-stack__button">' + this.esc(p.name) + '-Extrakt</a></article>';
        });
        return html;
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
